import { useState } from "react";
import { discussTopics } from "@/mocks/guagua";
import SectionHead from "./SectionHead";

export default function Discuss() {
  const [filter, setFilter] = useState<"全部" | "热门">("全部");
  const [liked, setLiked] = useState<number[]>([]);
  const [expanded, setExpanded] = useState<number[]>([]);

  const list = filter === "热门" ? discussTopics.filter((t) => t.hot) : discussTopics;

  const toggle = (arr: number[], id: number) => (arr.includes(id) ? arr.filter((x) => x !== id) : [...arr, id]);

  return (
    <section id="discuss" className="scroll-mt-24 lg:scroll-mt-[132px] py-12 md:py-16 bg-background-100 border-y border-background-200">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHead
            kicker="GUAYOU·TAOLUN"
            title="瓜友讨论区"
            desc="吃瓜就要一起聊，看看其他瓜友都在争什么。理性发言，文明吃瓜，欢迎亮出你的观点。"
          />
          <div className="inline-flex items-center gap-1 p-1 rounded-full bg-background-50 border border-background-200">
            {(["全部", "热门"] as const).map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`px-4 py-1.5 text-sm rounded-full transition-colors whitespace-nowrap ${
                  filter === f ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-900"
                }`}
              >
                {f === "热门" ? <><i className="ri-fire-fill mr-1"></i>热门</> : f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 space-y-4">
          {list.map((t) => {
            const isLiked = liked.includes(t.id);
            const isExpanded = expanded.includes(t.id);
            return (
              <div key={t.id} className="rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <button
                    onClick={() => setLiked((s) => toggle(s, t.id))}
                    className={`shrink-0 flex flex-col items-center justify-center w-14 h-14 rounded-xl border transition-colors ${
                      isLiked ? "border-primary-500 bg-primary-500 text-background-50" : "border-background-300 text-foreground-400 hover:border-primary-400 hover:text-primary-500"
                    }`}
                    aria-label={isLiked ? "取消点赞" : "点赞"}
                  >
                    <i className={`${isLiked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} text-lg`}></i>
                    <span className="text-[11px] mt-0.5">{t.replies}</span>
                  </button>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      {t.hot && (
                        <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-700 text-xs flex items-center gap-1">
                          <i className="ri-fire-fill"></i> 热门
                        </span>
                      )}
                      <h3 className="text-base font-medium text-foreground-950 leading-snug">{t.topic}</h3>
                    </div>
                    {isExpanded && (
                      <p className="mt-3 text-sm text-foreground-600 leading-relaxed bg-background-100 rounded-xl p-3 news-tab-fade">
                        {t.firstReply}
                      </p>
                    )}
                    <div className="mt-3 flex flex-wrap items-center gap-4 text-xs text-foreground-500">
                      <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i> {t.replies} 条讨论</span>
                      <span className="flex items-center gap-1"><i className="ri-user-smile-line"></i> 最新：{t.latest}</span>
                      <button
                        onClick={() => setExpanded((s) => toggle(s, t.id))}
                        className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-700 font-medium"
                      >
                        {isExpanded ? "收起" : "看看第一楼"} <i className={`ri-arrow-down-s-line ${isExpanded ? "rotate-180" : ""} transition-transform`}></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-6 rounded-2xl bg-background-50 border border-dashed border-background-300 p-5 md:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 rounded-full bg-accent-100 text-accent-800 flex items-center justify-center text-xl shrink-0">
              <i className="ri-chat-new-line"></i>
            </span>
            <div>
              <p className="text-foreground-950 font-medium text-[15px]">有瓜想说，无处可发？</p>
              <p className="text-xs text-foreground-500">到评论区抢个楼，或点下方按钮加入讨论，和你同频率的瓜友都在。</p>
            </div>
          </div>
          <a
            href="#faq"
            className="whitespace-nowrap shrink-0 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors inline-flex items-center gap-2"
          >
            我要发言 <i className="ri-send-plane-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}